import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  ICreateCompanyJobResponseData,
  ICreateCompanyJobArgs,
} from "./createCompanyJob.schema";
import { ZealApiSuccessResponse } from "@zeal/common";

type SuccessResponse = ZealApiSuccessResponse<ICreateCompanyJobResponseData>;

export const createCompanyJob = (axios: IAxiosInstance) => {
  return async (params: ICreateCompanyJobArgs) => {
    try {
      const response = await axios.noRetry.post<SuccessResponse>(
        `/api/company-jobs`,
        params
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
